var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { spacing, color, typography, controls } from '../../../constants';
export var Main = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var Supportive = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var ellipsis = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var compactDensity = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: ", ";\n  &,\n  ", " {\n    ", "\n  }\n  ", " {\n    display: none;\n  }\n"], ["\n  height: ", ";\n  &,\n  ", " {\n    ", "\n  }\n  ", " {\n    display: none;\n  }\n"])), controls.height.thin, Main, ellipsis, Supportive);
var looseDensity = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  min-height: 56px;\n  ", " {\n    display: block;\n  }\n"], ["\n  min-height: 56px;\n  ", " {\n    display: block;\n  }\n"])), Supportive);
var defaultDensity = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n  height: 56px;\n  &,\n  ", ", ", " {\n    ", "\n  }\n"], ["\n  ", "\n  height: 56px;\n  &,\n  ", ", ", " {\n    ", "\n  }\n"])), looseDensity, Main, Supportive, ellipsis);
function denseStyles(density) {
    switch (density) {
        case 'compact':
            return compactDensity;
        case 'loose':
            return looseDensity;
        default:
            return defaultDensity;
    }
}
/** 'appearance' prop styles */
/** default */
var defaultStyles = css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: ", " ", ";\n  border-bottom: 1px solid ", ";\n\n  a {\n    color: ", ";\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: ", " ", ";\n  border-bottom: 1px solid ", ";\n\n  a {\n    color: ", ";\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    /** 'plain' */
])), spacing.tight, spacing.snug, color.theme.supportingColor.tint, color.theme.primaryColor.action.primary);
/** 'plain' */
var plainStyles = css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n  padding: 0;\n"], ["\n  ", ";\n  padding: 0;\n"
    /** 'unstyled' */
])), defaultStyles);
/** 'unstyled' */
var unstyledStyles = '';
function getCellAppearanceStyles(_a) {
    var appearance = _a.appearance;
    switch (appearance) {
        case 'unstyled':
            return unstyledStyles;
        case 'plain':
            return plainStyles;
        default:
            return defaultStyles;
    }
}
export var DataGridCell = styled.div.attrs(function (_a) {
    var className = _a.className;
    return ({
        className: (className !== undefined ? className : '') + " DataGrid-Cell"
    });
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n  ", "\n  ", "\n  ", "\n\n  /**\n    By default, a flex item cannot be smaller than the size of its content.\n    The initial setting on flex items is 'min-width: auto'. Enable flex items to shrink their content with 'min-width: 0'\n  */\n  .DataGrid-CellWrapper {\n    min-width: 0;\n  }\n"], ["\n  ", ";\n  ", "\n  ", "\n  ", "\n\n  /**\n    By default, a flex item cannot be smaller than the size of its content.\n    The initial setting on flex items is 'min-width: auto'. Enable flex items to shrink their content with 'min-width: 0'\n  */\n  .DataGrid-CellWrapper {\n    min-width: 0;\n  }\n"])), getCellAppearanceStyles, function (_a) {
    var minWidth = _a.minWidth;
    return minWidth !== undefined && "min-width: " + minWidth + ";";
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth !== undefined && "max-width: " + maxWidth + ";";
}, function (_a) {
    var cursor = _a.cursor;
    return cursor !== undefined && "cursor: " + cursor + ";";
});
export var CompactCell = styled(DataGridCell)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n\n  ", " {\n    ", "\n    color: ", ";\n    margin-top: 2px;\n  }\n  ", ";\n"], ["\n  ", "\n  color: ", ";\n\n  ", " {\n    ", "\n    color: ", ";\n    margin-top: 2px;\n  }\n  ", ";\n"])), typography.dataGridMainText, color.theme.typography.ink, Supportive, typography.dataGridSupportingText, color.theme.typography.subdued, function (_a) {
    var density = _a.density;
    return denseStyles(density);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=Cell.styles.js.map